import React from 'react';
import FormDialog from '../../../library/form/components/FormDialog';
import withView from '../../cmn/docAutomation/withView';
import FormInput from '../../../library/form/components/FormInput';
import FormCheckbox from '../../../library/form/components/FormCheckbox';
import FormLabel from '../../../library/form/components/FormLabel';
import FormRichText from '../../../library/form/components/FormRichText';
import SarasTrans from '../../../library/notifications/SarasTrans';
import FormTitle from '../../../library/form/components/FormTitle';
import FormWrapper from '../../../library/form/components/FormWrapper';
import FormButton from '../../../library/form/components/FormActionButton2';
import FormAttachment from '../../../library/form/components/FormAttachment';
import FormROValue from '../../../library/form/components/FormROValue1';

const InvItemDiscountEditor = (props) => {
    const { formObject, viewData, ...restProps } = props;
    return (
        <FormDialog onDynamicViewClose={restProps.onDynamicViewClose} enablePopup={true}
            action={{ formActions: { forAction: "Confirm", forCancel: "Cancel" } }}
            formStyle={{ height: '550px' }}
            contentStyle={{ height: '435px', width: "760px" }}
            formTitle={<FormTitle formObject={formObject} value='Order Item' />}
            formObject={formObject} >
            <div id="invitemDetailMain" className="uiitemDetailMain" >
                <div className="uiROHeader">
                    <div style={{ display: "inline-block" }}>
                        <FormAttachment formObject={formObject} rowKey="" imgHeight="50px" action={{ InputType: "i", paramName: "itemImage" }} />
                    </div>
                    <div id="itemDetailReadonly" style={{ display: "inline-block" }} >
                        <span className="uiLblInLine">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "itemIdReadOnly" }} value="Item" />
                        </span>
                        <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "itemIdReadOnly" }} className='uiVal' />
                    </div>
                    <FormWrapper customWrapper="div" wrapperStyle={{ display: "inline-block" }} formObject={formObject} rowKey="" action={{ paramName: "itemSearchContainer" }} >
                        <span className="uiLblInLine">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "itemId" }} value="Item Id / No" />
                        </span>
                        <FormInput formObject={formObject} rowKey="" className="uiInput" maxlength="20"
                            action={{ InputType: "input", paramName: "itemId" }} />
                        <FormButton formObject={formObject} rowKey="" className="uiSaveAction" text={<SarasTrans value="Update Item" />}
                            action={{ actionId: "refresh", actionParam: { changeitem: 1 } }}
                        />
                    </FormWrapper>
                    <div style={{ display: "inline-block" }}>
                        <span className="uiLblInLine">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "transCat" }} value="Category" />
                        </span>
                        <FormInput formObject={formObject} rowKey="" className="uiInput"
                            action={{ InputType: "ac", paramName: "transCat", acMethod: "CategoryDetail", acDepCtrl: { dparam: '%dataList.valLCat' } }}
                        />
                    </div>
                </div>
                <FormWrapper customWrapper="div" formObject={formObject} rowKey="" action={{ paramName: "itemQtyContainer" }} >
                    <div>
                        <FormWrapper formObject={formObject} rowKey="" action={{ paramName: "itemCostContainer1" }} >
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "priceType" }} value="Price Type" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className="uiInput" action={{
                                InputType: "ac", actionId: "refresh",
                                paramName: "priceType", acMethod: "PriceType", actionParam: { updateNetAmount: "1" }
                            }}
                            />
                        </FormWrapper>
                        <FormWrapper formObject={formObject} rowKey="" action={{ paramName: "itemSalesContainer1" }} >
                            <span className="uiLblInLine">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "taxTemplate" }} value="Tax" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className="uiInput" action={{
                                InputType: "ac", actionId: "refresh", paramName: "taxTemplate",
                                acMethod: "CategoryDetail", acDepCtrl: { dparam: '%dataList.valLCat' }, actionParam: { updateNetAmount: "1" }
                            }}
                            />
                            <span className="uiLblInLine">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "includesTax" }} value="Price includes Tax" />
                            </span>
                            <FormCheckbox formObject={formObject} rowKey=''
                                action={{ InputType: "onOff", actionId: "refresh", paramName: "includesTax", actionParam: { updateNetAmount: "1" } }}
                            />
                        </FormWrapper>
                    </div>
                </FormWrapper>
                <div>
                    <ul className="uiItemPopupForm">
                        <FormWrapper formObject={formObject} rowKey="" action={{ paramName: "itemCostContainer2" }} >
                            <li>
                                <div className="uiColumn">
                                    <span className="uiLbl">
                                        <SarasTrans value="Discount Amount" />
                                    </span>
                                    <FormInput formObject={formObject} rowKey="" className="uiInput" maxlength="24"
                                        action={{ InputType: "input", actionId: "refresh", paramName: "unitPrice", actionParam: { formulaSource: "UP", updateNetAmount: "1" } }} />
                                </div>
                                <div className="uiColumn">
                                    <span className="uiLbl">
                                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "amtAfterQC" }} value="Total Amount" />
                                    </span>
                                    <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "amtAfterQC" }} className='uiVal' />
                                </div>
                            </li>
                        </FormWrapper>
                        <FormWrapper formObject={formObject} rowKey="" action={{ paramName: "itemSalesContainer2" }} >
                            <li>
                                <div className="uiColumn">
                                    <span className="uiLbl">
                                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "netAmt" }} value="Before Tax" />
                                    </span>
                                    <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "netAmt" }} className='uiVal' />
                                    <span className="uiLblInLine">
                                        <SarasTrans value="Tax Reduced" />
                                    </span>
                                    <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "totalTaxAmt" }} className='uiVal' />
                                </div>
                            </li>
                        </FormWrapper>
                    </ul>
                </div>

                <div>
                    <ul className="uiItemPopupForm">
                        <li>
                            <div className="uiColumn">
                                <span className="uiLbl">
                                    <SarasTrans value="Voucher Code" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" className=""
                                    action={{ InputType: "input", paramName: "refNo" }}
                                />
                            </div>
                        </li>
                        <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "itemName" }} >
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "itemName" }} value="Reference Name" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className="uiInputLong"
                                action={{ InputType: "input", paramName: "itemName" }}
                            />
                        </FormWrapper>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "itemDesc" }} value="Description" />
                            </span>
                            <FormRichText formObject={formObject} rowKey="" id="delInstTxt" className="uiFrmText" rows="3" cols="82" maxlength="1000"
                                action={{ paramName: "itemDesc" }}
                            />
                        </li>
                    </ul>
                </div>
            </div>

        </FormDialog>
    )
}

export default withView(InvItemDiscountEditor, "itemDetail", "itemDetail,invTrnFooter,invTrans,ccbreakup,invTrnTracker")
